import React from 'react';
import styled, { css } from 'styled-components';

const LabelElement = styled.label`
  color: rgba(0, 0, 0, .55);
  font-size: 12px !important;
   
  position: absolute;
  transform: translate(10px, -8px);
  background: #fff;
  padding: 2px;
  padding: 2px 8px 2px 8px;
  z-index: 99;
`;

const SelectElement = styled.select`
  height: 50px;
  background: #fff !important;
  border: 1.5px solid rgba(0, 0, 0, .55) !important;
  border-radius: 6px !important;
  appearance: auto !important;

  &:disabled {
    color: #A0A0A0;
  }

  &::-ms-expand {
    display: none;
  }

  &::after {
    content: "Hello";
  }

  ${(props) => props.short && css`
    height: 30px; 
  `}
`;

const Select = ({
  id,
  name,
  label,
  children,
  selectRef,
  ariaLabel,
  ...props
}) => (
  <>
    {
      label ? (
        <LabelElement htmlFor={id}>{label}</LabelElement>
      ) : null
    }
    <SelectElement
      id={id}
      name={name}
      ref={selectRef}
      aria-label={ariaLabel || 'select one of the options'}
      {...props}
    >
      {children}
    </SelectElement>
  </>
);

export default Select;
